import React, { useEffect, useState } from 'react';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';
import { useSystem } from "src/hooks/system";

// Note: If update anything for this component Please make sure update the same for the QuoteQuantityScheduler
const Action = (props) => {
    let l = 0;
    if (props.CART_DATA_SINGLE && props.CART_DATA_SINGLE.scheduleDetails?.length) {
        l = props.CART_DATA_SINGLE.scheduleDetails.length;
    }
    return (
        <a
            onClick={() => {
                System.popup('DateSchedulePopup', { CART_DATA_SINGLE: props.CART_DATA_SINGLE, CART_PRODUCT_DATA: props.CART_PRODUCT_DATA, single_product_inventory: props.single_product_inventory })
            }}
        > {l > 0 ? 'Edit ' : 'Add '} Schedule Date{l > 0 ? '(s)' : ''}</a>
    )
};

const QuantityScheduler = (props) => {
    const { CART_DATA_SINGLE } = props
    const [asAvailableQuantity, setAsAvailableQuantity] = useState(CART_DATA_SINGLE?.quantity ? CART_DATA_SINGLE?.quantity : 0);
    const [,{ get_quantity_format }] = useSystem();

    useEffect(() => {
        if (CART_DATA_SINGLE && CART_DATA_SINGLE?.scheduleDetails?.length) {
            let sum = 0;
            CART_DATA_SINGLE.scheduleDetails.forEach(ele => {
                sum += ele.quantity;
            });

            let avlQty = CART_DATA_SINGLE.quantity - sum;
            setAsAvailableQuantity(avlQty)
        }

    }, [CART_DATA_SINGLE]);

    return (
        <>
            {CART_DATA_SINGLE && CART_DATA_SINGLE.scheduleDetails && CART_DATA_SINGLE.scheduleDetails.length > 0 &&
                <>
                    <div className="mb-3">
                        <span className="font_bold_currency">Scheduled Dates</span>
                        <div className="sceduledate-list border-bottom1 mb-1">
                            {CART_DATA_SINGLE.scheduleDetails.length > 0 &&
                                <>
                                    <div className="d-flex  border-bottom1 justify-content-between">
                                        <div className="col-4 ps-0">Quantity</div>
                                        <div className="col-8 ps-0">Ship Date</div>
                                    </div>
                                    {asAvailableQuantity > 0 ?
                                        <div className="bs5 row m-0">
                                            <div className="col-4 ps-0">{get_quantity_format(asAvailableQuantity)}</div>
                                            <div className="col-8 ps-0">
                                                As Available
                                            </div>
                                        </div> : null}
                                    {CART_DATA_SINGLE.scheduleDetails.map((v, i) => (
                                        <div className="bs5 row m-0" key={i}>
                                            <div className="col-4 ps-0">{get_quantity_format(v.quantity)}</div>
                                            <div className="col-8 ps-0">
                                                {Helper.dateFormatFromString(v.scheduledDate)}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            }
                        </div>
                    </div>
                </>
            }
            <Action
                CART_DATA_SINGLE={CART_DATA_SINGLE}
                CART_PRODUCT_DATA={props.CART_PRODUCT_DATA}
                single_product_inventory={props.single_product_inventory}
            />
        </>
    );
}

export default QuantityScheduler;